import { capitalize } from "lodash";
import { ITableTab } from "../components/Table/components/TableTabs/TableTabs.types";
import { IRecordCount, IWhatsappCount } from "../redux/common/common.types";
import { IndianPriceFormatter } from "./formatWithCommas";

export const createTabsWithRecordcounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IRecordCount[],
): ITableTab[] => {
  let totalCount = 0;

  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find((obj) => {
      const statusNormalized = (obj.status || "").toLowerCase().replace(/_/g, " ");
      const valueNormalized = (item.value || "").toLowerCase().replace(/_/g, " ");
      return statusNormalized === valueNormalized;
    });
    const count = countObj ? countObj.count : 0;
    totalCount = totalCount + count;
    return {
      label: item.label,
      value: item.value,
      count: count,
      variant: item.variant,
    };
  });
  mergedArray.unshift({
    label: "All",
    value: "-1",
    count: totalCount,
    variant: "primary",
  });
  return mergedArray as ITableTab[];
};

export const getVariant = (value: string) => {
  const status = value.toLowerCase();

  if (status === "hold") {
    return "warning";
  } else if (status === "ongoing") {
    return "info";
  } else if (status === "booked") {
    return "success";
  } else if (status === "cancelled") {
    return "error";
  } else if (status === "postponed") {
    return "primary";
  }

  return "default";
};
export const createTabsWithRecordcountsV2 = (
  // mainData: { label: string; value: string; variant: string }[],
  recordCounts: IRecordCount[],
): ITableTab[] => {
  let totalCount = 0;

  const mergedArray = recordCounts.map((item) => {
    totalCount = totalCount + item.count;
    return {
      label: capitalize(item.status || ""),
      value: item.status,
      count: item.count,
      variant: getVariant(item.status),
    };
  });
  mergedArray.unshift({
    label: "All",
    value: "-1",
    count: totalCount,
    variant: "primary",
  });
  return mergedArray as ITableTab[];
};

export const createTabsWithWhatsappcounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IWhatsappCount[],
): ITableTab[] => {
  let totalCount = 0;

  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find(
      (obj) => (obj.status || "").toLowerCase() === item.value.toLowerCase(),
    );
    const count = countObj ? countObj.cnt : 0;
    totalCount = totalCount + count;
    return {
      label: item.label,
      value: item.value,
      count: count,
      variant: item.variant,
    };
  });
  mergedArray.unshift({
    label: "All",
    value: "-1",
    count: totalCount,
    variant: "primary",
  });
  return mergedArray as ITableTab[];
};

export const createTabsWithPaymentTransactionCounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IRecordCount[],
): ITableTab[] => {
  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find(
      (obj) => (obj.status || "").toLowerCase() === item.value.toLowerCase(),
    );
    const count = countObj ? countObj.count : 0;
    return {
      label: item.label,
      value: item.value,
      count: IndianPriceFormatter(count),
      variant: item.variant,
    };
  });

  return mergedArray as unknown as ITableTab[];
};
